import React, { useState, useContext, useEffect, Fragment } from "react";
import { Navigate } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { AuthContext } from "../../context/AuthContext";
import { AlertContext } from "../../context/AlertContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { getBrand, createBrandTheme } from "../../theme/brand";
import Spinner from "../layout/Spinner";
import Barra from "../layout/Barra";

export default function Password() {
  const { state, changePassword, usuarioAutenticado } = useContext(AuthContext);
  const { mensajeAlerta } = useContext(AlertContext);
  const { configuracion } = useContext(ConfiguracionContext);

  const [clave, setClave] = useState({ password: "", password2: "" });
  const [redirect, setRedirect] = useState(false);
  const theme = createBrandTheme(getBrand(configuracion));

  const { password, password2 } = clave;

  useEffect(() => {
    usuarioAutenticado();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.id]);

  const cambiarPassword = (e) => {
    e.preventDefault();

    if (state.usuario.usuario.trim() === "") {
      mensajeAlerta("Registro de Usuarios", "El usuario es necesario !.", "error");
      return;
    }
    if (state.usuario.email.trim() === "") {
      mensajeAlerta("Registro de Usuarios", "El email es necesario !.", "error");
      return;
    }
    if (password.trim() === "") {
      mensajeAlerta(
        "Registro de Usuarios",
        "El password es incorrecto !.",
        "error",
      );
      return;
    }
    if (password.length < 6) {
      mensajeAlerta(
        "Registro de Usuarios",
        "El password debe tener al menos 6 caracteres !.",
        "error",
      );
      return;
    }
    if (password2 !== password) {
      mensajeAlerta(
        "Registro de Usuarios",
        "Los password son diferentes !.",
        "error",
      );
      return;
    }

    changePassword({ usuarioId: state.usuario.id, password });
    setRedirect(true);
  };

  return (
    <Fragment>
      <Barra />

      {!state.usuario ? <Spinner /> : null}

      {state.usuario ? (
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="sm" sx={{ py: 4 }}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, sm: 4 },
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mb: 3,
                }}
              >
                <Avatar sx={{ bgcolor: "primary.main", mb: 1 }}>
                  <LockOutlinedIcon />
                </Avatar>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  Cambiar Password
                </Typography>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    name="usuario"
                    fullWidth
                    id="usuario"
                    label="Usuario"
                    value={state.usuario.usuario}
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="email"
                    label="Dirección de Email"
                    name="email"
                    value={state.usuario.email}
                    disabled
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) =>
                      setClave({ ...clave, password: e.target.value })
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    required
                    fullWidth
                    name="password2"
                    label="Repetir password"
                    type="password"
                    id="password2"
                    value={password2}
                    onChange={(e) =>
                      setClave({ ...clave, password2: e.target.value })
                    }
                  />
                </Grid>
              </Grid>

              <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3 }}
                onClick={cambiarPassword}
              >
                Cambiar Password
              </Button>
            </Paper>
          </Container>
          {redirect ? <Navigate to="/" /> : null}
        </ThemeProvider>
      ) : null}
    </Fragment>
  );
}
